"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavigationRoot;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const native_stack_1 = require("@react-navigation/native-stack");
const native_base_1 = require("native-base");
const react_1 = require("react");
const react_native_2 = require("react-native");
const react_redux_1 = require("react-redux");
const posthog_react_native_1 = require("posthog-react-native");
const application_host_1 = require("../common/application-host");
const routing_1 = __importDefault(require("../common/routing"));
const colors_1 = require("../common/colors");
const useAppQuota_1 = require("../hooks/useAppQuota");
const useDevice_1 = require("../hooks/useDevice");
const AnalyticsProvider_1 = __importDefault(require("../providers/AnalyticsProvider"));
const AppSocketProvider_1 = __importDefault(require("../providers/AppSocketProvider"));
const AccountSettings_1 = __importDefault(require("../screen/AccountSettings"));
const AdminConfig_1 = __importDefault(require("../screen/AdminConfig"));
const AppPage_1 = __importDefault(require("../screen/AppPage"));
const Preferences_1 = __importDefault(require("../screen/Preferences"));
const WebPage_1 = __importDefault(require("../screen/WebPage"));
const Summary_1 = __importDefault(require("../screen/Summary"));
const DiscoverTabs_1 = __importDefault(require("./DiscoverTabs"));
const DiscoverDrawer_1 = __importDefault(require("./DiscoverDrawer"));
const ChevronBackButton_1 = __importDefault(require("./ChevronBackButton"));
const OneToOneChat_1 = __importDefault(require("../screen/OneToOneChat"));
const subscription_1 = require("../slices/subscription");
const appState_1 = require("../slices/appState");
const store_1 = require("../store");
const user_1 = require("../store/selectors/user");
const document_1 = require("../store/selectors/document");
const appState_2 = require("../store/selectors/appState");
const user_2 = require("../slices/user");
const document_2 = require("../slices/document");
const document_3 = require("../services/document");
const AppLoadActions_1 = __importDefault(require("./AppLoadActions"));
const rootNavigation_1 = require("./rootNavigation");
const AddSources_1 = __importDefault(require("../component/AddSources"));
const CookiesAdvice_1 = __importDefault(require("../component/CookiesAdvice"));
const LoginModal_1 = __importDefault(require("../component/LoginModal"));
const UsernameModal_1 = __importDefault(require("../component/UsernameModal"));
const ShareModal_1 = __importDefault(require("../component/ShareModal"));
const modals_1 = require("../component/modals");
const DocumentHeaderItem_1 = __importDefault(require("../component/DocumentHeader/DocumentHeaderItem"));
const AppText_1 = require("../component/AppText");
const AppButton_1 = require("../component/AppButton");
const GoBackButton_1 = __importDefault(require("../component/GoBackButton"));
const ChatRightHeader_1 = __importDefault(require("../component/Conversations/ChatRightHeader"));
const NoteButton_1 = __importDefault(require("../component/NoteButton"));
const SoundBiteButton_1 = __importDefault(require("../component/SoundBiteButton"));
const useRequest_1 = __importDefault(require("../hooks/useRequest"));
const useDocument_1 = __importDefault(require("../hooks/useDocument"));
const useAppMessage_1 = require("../hooks/useAppMessage");
const DeactivateAccount_1 = __importDefault(require("../screen/AccountSettings/DeactivateAccount"));
const DeleteReason_1 = __importDefault(require("../screen/AccountSettings/DeleteReason"));
const FeatureList_1 = __importDefault(require("../screen/AccountSettings/FeatureList"));
const DiscoverHeader_1 = __importDefault(require("./DiscoverHeader"));
const NavSidebarTabs_1 = __importDefault(require("./NavSidebarTabs"));
const firebase_1 = require("../auth/firebase");
const spacing_1 = require("../common/spacing");
const react_native_reanimated_1 = __importStar(require("react-native-reanimated"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const constants_1 = require("../common/constants");
const character_1 = require("../services/character");
const GenericlModal_1 = __importDefault(require("../component/GenericlModal"));
const ConfigurePrompts_1 = __importDefault(require("../screen/ConfigurePrompts"));
const PurchasePlans_1 = __importDefault(require("../screen/PurchasePlans"));
const Feedback_1 = __importDefault(require("../screen/Feedback"));
const Search_1 = __importDefault(require("../component/Search"));
const RootStack = (0, native_stack_1.createNativeStackNavigator)();
const TalkTooTheme = {
    ...native_1.DefaultTheme,
    colors: {
        ...native_1.DefaultTheme.colors,
        background: colors_1.Colors.DARK_700,
    },
};
/**
 *
 * @returns
 */
const Navigation = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { isWebDevice, isMobileScreen, deviceWidth, deviceHeight } = (0, useDevice_1.useDevice)();
    const { request } = (0, useRequest_1.default)();
    const { showShareLink, startDocumentConversation } = (0, useDocument_1.default)();
    const characterProfile = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterProfile);
    const conversation = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation);
    const selectedDocumentJson = (0, react_redux_1.useSelector)(document_1.selectDocumentJson);
    const isDocumentConversationOpen = (0, react_redux_1.useSelector)(document_1.selectIsDocumentConversationOpen);
    const selectedFontId = (0, react_redux_1.useSelector)((state) => state.fontSettings.selectedFontId); // Get selected font ID
    const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === selectedFontId); // Find the selected font
    const fontFamily = selectedFont?.fontFamily || 'System'; // Default to 'System' if no font is selected
    const navigation = (0, native_1.useNavigation)();
    const [isUpdateTitleModalOpen, setIsUpdateTitleModalOpen] = (0, react_1.useState)(false);
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const documentCharacter = (0, react_redux_1.useSelector)(user_1.selectCharacterProfile);
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const handleUpdateTitle = async (document, title) => {
        try {
            if (!documentCharacter)
                throw new Error('Document JSON is undefined');
            const newFileResponse = await request(document_3.editDocumentTitle, document, title);
            if (newFileResponse?.data.characterId === characterProfile.id.toString()) {
                dispatch((0, user_2.patchCharacter)({ characterName: newFileResponse.data.fileName }));
            }
            showNotification('Success', 'Title updated successfully', 'success');
            // onClose();
        }
        catch (error) {
            console.error('Error updating title:', error);
            showNotification('Error', 'Failed to update title', 'error');
        }
    };
    const handleChangeStyleSelection = (0, react_1.useCallback)((finalSelection) => {
        if (documentCharacter) {
            request(character_1.createEditCharacter, {
                id: documentCharacter.id,
                characterName: documentCharacter.characterName,
                background: documentCharacter.background,
                styleString: finalSelection.imageModel?.styleString,
                imageModelId: finalSelection.modelId,
                aspectRatio: finalSelection.aspectRatio,
            }, true).then((characterResponse) => {
                if (characterResponse) {
                    dispatch((0, user_2.setCharacter)(characterResponse.data));
                }
            });
        }
    }, [documentCharacter, request, dispatch]);
    return ((0, jsx_runtime_1.jsxs)(RootStack.Navigator, { initialRouteName: "Home", screenOptions: { gestureEnabled: true }, children: [(0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "Home", options: {
                    header: () => ((0, jsx_runtime_1.jsx)(DiscoverHeader_1.default, { style: {
                            paddingHorizontal: 20,
                            paddingVertical: 24,
                        } })),
                    gestureEnabled: false,
                    headerBackVisible: false,
                    headerShown: isWebDevice && isMobileScreen,
                }, component: isWebDevice && isMobileScreen ? DiscoverDrawer_1.default : DiscoverTabs_1.default }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "OneToOneChat", options: {
                    headerLeft: ({ canGoBack }) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            gap: 5,
                            flexDirection: 'row',
                            alignItems: 'center',
                            paddingLeft: spacing_1.Spacing.SPACING_XS,
                        }, children: [(0, jsx_runtime_1.jsx)(ChevronBackButton_1.default, { backRoute: !canGoBack ? ['Summary', { conversationId: conversation?.id }] : undefined }), characterProfile.id && conversation && ((0, jsx_runtime_1.jsx)(DocumentHeaderItem_1.default, { character: characterProfile, onPress: () => {
                                    navigation.navigate('Summary', { conversationId: conversation.id });
                                } }))] })),
                    headerRight: () => (0, jsx_runtime_1.jsx)(ChatRightHeader_1.default, {}),
                    header: ({ options, navigation, route }) => {
                        const HeaderLeft = options.headerLeft?.({
                            canGoBack: navigation.canGoBack(),
                        });
                        const HeaderRight = options.headerRight?.({
                            canGoBack: navigation.canGoBack(),
                        });
                        return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                gap: 10,
                                paddingBottom: spacing_1.Spacing.SPACING_MD,
                            }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        paddingRight: spacing_1.Spacing.SPACING_XL,
                                        marginTop: 10,
                                    }, children: [HeaderLeft, HeaderRight] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', gap: 16 }, children: [(0, jsx_runtime_1.jsx)(NoteButton_1.default, { style: { borderRadius: 12 }, onPress: () => {
                                                navigation.navigate('Summary', { ...route.params, notes: true });
                                            }, fullWidth: true, navigationButton: true }), (0, jsx_runtime_1.jsx)(SoundBiteButton_1.default, { onPress: () => {
                                                navigation.navigate('Summary', { ...route.params, audio: true });
                                            }, fullWidth: true })] })] }));
                    }
                }, component: OneToOneChat_1.default }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "WebPage", component: WebPage_1.default, options: {
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "Search", component: Search_1.default, options: {
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "Search",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "LoginPage", component: LoginModal_1.default, options: {
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "Feedback", component: Feedback_1.default, options: {
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "AppPage", component: AppPage_1.default, options: {
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "DeleteAccountReason", component: DeleteReason_1.default, options: {
                    gestureEnabled: true,
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "DeactivateAccount", component: DeactivateAccount_1.default, options: {
                    gestureEnabled: true,
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "PurchasePlans", component: PurchasePlans_1.default, options: {
                    gestureEnabled: true,
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily,
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "FeatureList", component: FeatureList_1.default, options: {
                    gestureEnabled: true,
                    headerTransparent: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily,
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "DevConfigs", component: AdminConfig_1.default, options: {
                    headerTransparent: true,
                    headerBackTitleVisible: true,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily,
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "Voices",
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "AccountSettings", component: AccountSettings_1.default, options: {
                    gestureEnabled: true,
                    headerBackVisible: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily, // Apply the selected font family
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "Account",
                    headerStyle: {
                        backgroundColor: colors_1.Colors.DARK_700,
                    },
                    header: () => ((0, jsx_runtime_1.jsx)(ChevronBackButton_1.default, { style: {
                            alignSelf: 'flex-start',
                            marginVertical: 29,
                            marginLeft: 16,
                        } }))
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "Preferences", component: Preferences_1.default, options: {
                    gestureEnabled: true,
                    headerBackVisible: true,
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily,
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "Preferences",
                    headerStyle: {
                        backgroundColor: colors_1.Colors.DARK_700,
                    },
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "Summary", component: Summary_1.default, options: ({ route: { params } }) => ({
                    headerLeft: ({ canGoBack }) => isMobileScreen ? ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            gap: 5,
                            flexDirection: 'row',
                            alignItems: 'center',
                            flex: 1,
                            paddingLeft: spacing_1.Spacing.SPACING_XS,
                        }, children: [selectedDocumentJson && !('shareId' in selectedDocumentJson) && ((0, jsx_runtime_1.jsx)(GenericlModal_1.default, { isOpen: isUpdateTitleModalOpen, onClose: () => setIsUpdateTitleModalOpen(false), onSubmit: (value) => handleUpdateTitle(selectedDocumentJson, value), modalTitle: "Update Title", initialValue: selectedDocumentJson.title || '', placeholderText: selectedDocumentJson.title, submitButtonText: "Set New Title" })), (0, jsx_runtime_1.jsx)(ChevronBackButton_1.default, { backRoute: ['Home', { screen: 'Documents' }] }), selectedDocumentJson && ((0, jsx_runtime_1.jsx)(react_native_2.Pressable, { onPress: () => setIsUpdateTitleModalOpen(true), style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: 'white', fontSize: 19, numberOfLines: 1, children: `​  ${('title' in selectedDocumentJson ? selectedDocumentJson.title : selectedDocumentJson.characterName).slice(0, 24) + (('title' in selectedDocumentJson ? selectedDocumentJson.title : selectedDocumentJson.characterName).length > 24 ? '...' : '')}` }) }))] })) : ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            flexDirection: 'row',
                            alignItems: 'center',
                            flex: 1,
                        }, children: [(0, jsx_runtime_1.jsx)(GoBackButton_1.default, { onPress: () => {
                                    if (canGoBack) {
                                        navigation.goBack();
                                    }
                                    else {
                                        navigation.navigate('Home', { screen: 'Documents' });
                                    }
                                }, style: {
                                    width: 32,
                                    height: 32,
                                    marginLeft: -16,
                                } }), selectedDocumentJson && !('shareId' in selectedDocumentJson) && ((0, jsx_runtime_1.jsx)(GenericlModal_1.default, { isOpen: isUpdateTitleModalOpen, onClose: () => setIsUpdateTitleModalOpen(false), onSubmit: (value) => selectedDocumentJson && handleUpdateTitle(selectedDocumentJson, value), modalTitle: "Update Title", initialValue: selectedDocumentJson.title || '', placeholderText: selectedDocumentJson.title, submitButtonText: "Set New Title" })), (0, jsx_runtime_1.jsx)(react_native_2.Pressable, { onPress: () => setIsUpdateTitleModalOpen(true), onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), style: ({ pressed }) => [
                                    {
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    },
                                ], children: ({ pressed }) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [
                                            {
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                padding: 4,
                                                borderRadius: 8,
                                            },
                                            (pressed || isHovered) && {
                                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            }
                                        ], children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: 'white', fontSize: 16, fontWeight: 'bold', maxWidth: ((selectedDocumentJson && ('title' in selectedDocumentJson ? selectedDocumentJson.title : selectedDocumentJson.characterName))?.length ?? 0) < 36 ? 348 : undefined, numberOfLines: 1, style: {
                                                    flexShrink: 1,
                                                }, children: `${((selectedDocumentJson
                                                    && ('title' in selectedDocumentJson ? selectedDocumentJson.title : selectedDocumentJson.characterName))?.replace(/\.(pdf|txt)$/, '') ?? '')}` }), (pressed || isHovered) && ((0, jsx_runtime_1.jsx)(react_native_reanimated_1.default.View, { entering: react_native_reanimated_1.FadeIn.duration(300), exiting: react_native_reanimated_1.FadeOut.duration(300), style: { marginLeft: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faPen, color: colors_1.Colors.white, size: 16 }) }))] }) })) })] })),
                    headerRight: () => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            gap: isMobileScreen ? 10 : spacing_1.Spacing.SPACING_3XL,
                            flexDirection: 'row',
                            alignItems: 'center',
                        }, children: [params
                                && !isMobileScreen
                                && ((0, jsx_runtime_1.jsx)(AppButton_1.ChatButton, { active: isDocumentConversationOpen, onPress: () => startDocumentConversation({
                                        shareId: params.shareId,
                                        ...(selectedDocumentJson
                                            && !('shareId' in selectedDocumentJson)
                                            && { documentJson: selectedDocumentJson }),
                                    }) })), selectedDocumentJson && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AppButton_1.SourcesButton, { document: selectedDocumentJson }), (0, jsx_runtime_1.jsx)(AppButton_1.ShareButton, { onPress: () => showShareLink(selectedDocumentJson) })] }))] })),
                    header: ({ options, navigation }) => {
                        const HeaderLeft = options.headerLeft?.({
                            canGoBack: navigation.canGoBack(),
                        });
                        const HeaderRight = options.headerRight?.({
                            canGoBack: navigation.canGoBack(),
                        });
                        return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                height: isMobileScreen ? 42 : 48,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                paddingHorizontal: isMobileScreen ? 0 : 32,
                                paddingRight: isMobileScreen ? 16 : 32,
                                paddingBottom: isMobileScreen ? 5 : 0,
                                marginTop: isMobileScreen ? 15 : 32,
                                borderColor: colors_1.Colors.DARK_500,
                                borderBottomWidth: isMobileScreen ? 0.5 : 0,
                            }, children: [HeaderLeft, HeaderRight] }));
                    }
                }) }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "SummaryChat", component: OneToOneChat_1.default, options: {
                    headerLeft: ({ canGoBack }) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            gap: 5,
                            flexDirection: 'row',
                            alignItems: 'center',
                            paddingLeft: spacing_1.Spacing.SPACING_XS,
                        }, children: [(0, jsx_runtime_1.jsx)(ChevronBackButton_1.default, { backRoute: !canGoBack ? ['Summary', { conversationId: conversation?.id }] : undefined }), characterProfile.id && conversation && ((0, jsx_runtime_1.jsx)(DocumentHeaderItem_1.default, { character: characterProfile, onPress: () => {
                                    navigation.navigate('Summary', { conversationId: conversation.id });
                                } }))] })),
                    headerRight: () => (0, jsx_runtime_1.jsx)(ChatRightHeader_1.default, {}),
                    header: ({ options, navigation, route }) => {
                        const HeaderLeft = options.headerLeft?.({
                            canGoBack: navigation.canGoBack(),
                        });
                        const HeaderRight = options.headerRight?.({
                            canGoBack: navigation.canGoBack(),
                        });
                        return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                gap: 10,
                                paddingBottom: spacing_1.Spacing.SPACING_MD,
                            }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        paddingRight: spacing_1.Spacing.SPACING_XL,
                                        marginTop: 10,
                                    }, children: [HeaderLeft, HeaderRight] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', gap: 16 }, children: [(0, jsx_runtime_1.jsx)(NoteButton_1.default, { style: { borderRadius: 12 }, onPress: () => {
                                                navigation.navigate('Summary', { ...route.params, notes: true });
                                            }, fullWidth: true, navigationButton: true }), (0, jsx_runtime_1.jsx)(SoundBiteButton_1.default, { onPress: () => {
                                                navigation.navigate('Summary', { ...route.params, audio: true });
                                            }, fullWidth: true })] })] }));
                    }
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "ConfigurePrompts", component: ConfigurePrompts_1.default, options: {
                    gestureEnabled: true,
                    headerLeft: () => ((0, jsx_runtime_1.jsx)(ChevronBackButton_1.default, { arrowBackIcon: true, iconSize: 20, style: {
                            marginVertical: 29,
                            marginLeft: 16,
                        } })),
                    headerBackTitleVisible: false,
                    headerTitleStyle: {
                        color: colors_1.Colors.white,
                        fontFamily: fontFamily,
                    },
                    headerTintColor: colors_1.Colors.white,
                    headerTitle: "Configure Prompts",
                    headerStyle: {
                        backgroundColor: colors_1.Colors.DARK_700,
                    },
                } }), (0, jsx_runtime_1.jsx)(RootStack.Screen, { name: "AddSources", component: AddSources_1.default, options: { headerShown: false } })] }));
};
/**
 *
 * @returns
 */
function NavigationRoot() {
    const { request } = (0, useRequest_1.default)();
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const selectedCharacter = (0, react_redux_1.useSelector)(user_1.selectCharacterProfile);
    const wasCookiesAccepted = (0, react_redux_1.useSelector)(appState_2.selectCookiesAccepted);
    const wasDocumentsFetched = (0, react_redux_1.useSelector)(document_2.selectWasDocumentsFetched);
    const shouldShowSidebar = (0, react_redux_1.useSelector)(appState_2.selectShouldShowSidebar);
    const isSharingApp = (0, react_redux_1.useSelector)(appState_2.selectIsSharingApp);
    const isCharacterSharing = (0, react_redux_1.useSelector)(appState_2.selectIsCharacterSharing);
    const documentShareState = (0, react_redux_1.useSelector)(document_1.selectDocumentShareState);
    const { isSharing: isDocumentSharing, shareUrl: documentShareUrl, isPasswordSet: isDocumentSharingPasswordSet, } = documentShareState;
    const sharingDocument = (0, store_1.useAppSelector)((state) => ((0, document_2.selectDocumentById)(state, 'documentId' in documentShareState ? documentShareState.documentId : '')));
    const appError = (0, react_redux_1.useSelector)(appState_2.selectAppError);
    const { deviceHeight, isMobileScreen } = (0, useDevice_1.useDevice)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { loadUserQuota } = (0, useAppQuota_1.useAppQuota)();
    const containerRef = React.useRef(null);
    const normalizedDeviceHeight = React.useMemo(() => deviceHeight - 1, [deviceHeight]);
    const onLoad = (0, react_1.useCallback)(async () => {
        if (appUser?.id) {
            const quota = await loadUserQuota();
            console.log("got navigation quota:", appUser.id, quota);
            if (quota) {
                dispatch((0, subscription_1.setUserQuota)({ uid: appUser.id, ...quota }));
            }
        }
    }, [appUser?.id]);
    const handleAcceptCookies = (0, react_1.useCallback)(async () => {
        dispatch((0, appState_1.setCookiesAccepted)(true));
        dispatch((0, user_2.createTemporaryUser)());
    }, []);
    (0, react_1.useEffect)(() => {
        if (appUser?.id) {
            onLoad();
        }
    }, [appUser?.id]);
    (0, react_1.useEffect)(() => {
        if (appUser?.id && !wasDocumentsFetched) {
            request(dispatch((0, document_2.fetchMyDocuments)()).unwrap);
        }
        ;
    }, [appUser, wasDocumentsFetched, request, dispatch]);
    (0, react_1.useEffect)(() => {
        const TOKEN_EXPIRATION_TIME = 3600000;
        const BEFORE_EXPIRATION_TIME = 300000;
        let refreshTokenInterval;
        (0, firebase_1.watchAuthState)(async (user) => {
            clearInterval(refreshTokenInterval);
            if (user) {
                const refreshedUserToken = await user.getIdToken(true);
                dispatch((0, user_2.setAuthToken)(refreshedUserToken));
                refreshTokenInterval = setInterval(async () => {
                    const refreshedUserToken = await user.getIdToken(true);
                    dispatch((0, user_2.setAuthToken)(refreshedUserToken));
                }, TOKEN_EXPIRATION_TIME - BEFORE_EXPIRATION_TIME);
            }
            ;
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (appError) {
            setTimeout(() => {
                showNotification(typeof appError === 'object' && appError.title || 'Error', typeof appError === 'string' ? appError : appError.message, 'error');
            });
            dispatch((0, appState_1.resetAppError)());
        }
        ;
    }, [appError]);
    return ((0, jsx_runtime_1.jsx)(native_1.NavigationContainer, { linking: (0, routing_1.default)({ isMobile: isMobileScreen }), ref: rootNavigation_1.navigationRef, theme: TalkTooTheme, children: (0, jsx_runtime_1.jsx)(native_base_1.NativeBaseProvider, { children: (0, jsx_runtime_1.jsx)(posthog_react_native_1.PostHogProvider, { apiKey: constants_1.POSTHOG_API_KEY, autocapture: {
                    captureTouches: false,
                    captureLifecycleEvents: false,
                    captureScreens: true,
                    navigation: {
                        routeToProperties: (_name, params) => {
                            return { params };
                        },
                    },
                }, options: {
                    enableSessionReplay: true,
                }, children: (0, jsx_runtime_1.jsx)(AnalyticsProvider_1.default, { children: (0, jsx_runtime_1.jsxs)(AppSocketProvider_1.default, { children: [(0, jsx_runtime_1.jsx)(AppLoadActions_1.default, {}), (0, jsx_runtime_1.jsxs)(react_native_1.View, { ref: containerRef, onTouchEnd: () => {
                                    window.scrollTo(0, 0);
                                }, style: { flexDirection: "row", height: normalizedDeviceHeight }, children: [!isMobileScreen && shouldShowSidebar && (0, jsx_runtime_1.jsx)(NavSidebarTabs_1.default, {}), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.TouchableWithoutFeedback, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Navigation, {}) }), (0, jsx_runtime_1.jsx)(UsernameModal_1.default, {}), (0, jsx_runtime_1.jsx)(CookiesAdvice_1.default, { shouldOpen: !wasCookiesAccepted, handleAccept: handleAcceptCookies }), (0, jsx_runtime_1.jsx)(ShareModal_1.default, { isOpen: isSharingApp, onClose: () => { dispatch((0, appState_1.setIsSharingApp)(false)); }, title: 'Invite a Friend', description: 'Invite a friend to summaraizer.com with this link', shareUrl: application_host_1.APP_HOST, shareText: "Or post an invite via socials" }), (0, jsx_runtime_1.jsx)(ShareModal_1.default, { isOpen: isCharacterSharing || isDocumentSharing, onClose: () => {
                                                    if (isCharacterSharing) {
                                                        dispatch((0, appState_1.setIsCharacterSharing)(false));
                                                    }
                                                    if (isDocumentSharing) {
                                                        dispatch((0, document_2.resetShareState)());
                                                    }
                                                }, title: 'Share', description: ((0, jsx_runtime_1.jsxs)(AppText_1.AppText, { children: ["Share", ' ', isCharacterSharing && selectedCharacter?.characterName ? ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: "white", fontWeight: 700, children: selectedCharacter.characterName })) : isDocumentSharing && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: "white", fontWeight: 700, children: sharingDocument?.character.characterName
                                                                || ('documentName' in documentShareState && documentShareState.documentName) })), ' ', "with a friend! Copy the link below"] })), shareUrl: isCharacterSharing
                                                    ? `${application_host_1.APP_HOST}/Chats/${selectedCharacter.id}`
                                                    : documentShareUrl ?? '', shareText: 'Or share this document on:', isPasswordSet: isDocumentSharingPasswordSet, isAudioLoading: sharingDocument?.isPodcastGenerating === 'Y'
                                                    && !sharingDocument.character.summary?.fiveMinWrapAudioUrl }), (0, jsx_runtime_1.jsx)(modals_1.ImageViewer, {})] })] })] }) }) }) }) }));
}
